export default function Kyugyobi() {
  return (
    <div className="flex items-center gap-4">
      {/* <p className="flex items-center gap-2 text-sm sm:text-base"><span className="bg-white border border-gray-300 w-5 h-5 inline-block"></span> -- 営業日</p> */}
      <p className="text-orange-500 flex items-center gap-2 text-sm sm:text-base"><span className="bg-orange-100 w-5 h-5 inline-block"></span> -- 休業日</p>
    </div>
  );
}
